import { HttpClient, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RootScopeService } from './root-scope.service';
import { Router } from '@angular/router';
import * as Constants from '../models/Constants';
import { Observable, catchError, forkJoin, map, of, switchMap, timer } from 'rxjs';
import { Global } from '../global/globalApi';
import { LogOutDTO, SessionDetailsDTO } from '../models/LogOutDTO';
import { LoginDTO } from '../models/LoginDTO';
import { NewAgentApiService } from './new-agent-api.service';
import { GenesysCloudService } from './genesys-cloud.service';
import { CallCustomerAttributes } from '../models/customer.model';
import { AwsSqsService } from './aws-sqs.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  // url = "https://10.41.131.46/"; //Nithya IP
  // url = "http://100.106.116.195:9091"; // Dinesh IP
  //url = 'https://10.41.151.63:9091/'; //Arun IP
  url = 'https://cct-dv-int.dcsa.aws.alight.com/';
  constructor(
    private newAgentApiService: NewAgentApiService,
    public rootScope: RootScopeService,
    public awsSQSService: AwsSqsService,
    private router: Router,
    private http: HttpClient,
    private genesysCloudService: GenesysCloudService
  ) { }


  logOut(): Observable<any> {
    let userId: any = localStorage.getItem('userId');
    let reqBody = new LogOutDTO();
    reqBody.geneSysUserId = userId;
    reqBody.emailId = this.rootScope.emailId;
    reqBody.sessionDetails = new SessionDetailsDTO();
    // console.log('this.rootScope.sessionId', this.rootScope.sessionId);
    reqBody.sessionDetails['sessionId'] = this.rootScope.sessionId;
    return this.http.delete(Global.domainUrl + Global.LOG_OFF_API, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      responseType: 'text',
      body: reqBody,
    });
  }

  /**
   * Below method handles triggering
   * of logff api and handling of api
   * failure or success.
   * If api fails, user needs to prompt alert msg and will NOT be
   * redirected to logoff page and vice versa
   */
  /* istanbul ignore next */
  userLogout() {
    this.rootScope.showLoader();
    this.logOut().subscribe({
      next: (res: any) => {
        if (res.includes('successfully')) {
          this.rootScope.isErrorToHide = true;
          this.rootScope._isAuthenticated.next(false);
          this.rootScope._isLogout.next(true);
          this.genesysCloudService.logOutALIS();
          this.rootScope.clearCache();
          //  this.router.navigate(['/log-out']);
        } else {
          this.rootScope.enableAlerts(
            Constants.ERROR,
            Constants.API_FAILURE_MSG
          );
          this.rootScope.captureLogsDb('USER-LOGOUT-ALIS-API-FAILURE:', Constants.ERROR);
        }
        this.rootScope.hideLoader();
      },
      error: (error) => {
        this.rootScope.enableAlerts(Constants.ERROR, Constants.API_FAILURE_MSG);
        this.rootScope.captureLogsDb('USER-LOGOUT-ALIS-API-FAILURE:', Constants.ERROR);
        this.rootScope.hideLoader();
      },
    });
  }

  /**
   * Below method handle the User Authenticate Service which validate the
   * User Credentials and in case of successful response it give redirect URL and
   * in case failure it give the errors.
   */
  login(reqBody: LoginDTO): Observable<any> {
    // console.log('Method login called');
    let headers = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .append('Connection', 'keep-alive')
      .append('version', Constants.apiVersions);
    let url = Global.domainUrl + Global.LOGIN_API;
    // let url = this.url +  Global.loginApi;
    // console.log('login url', url);
    return this.http.post(url, reqBody, {
      headers: headers,
    });
  }

  handleMultiSession(createNewSession) {
    this.rootScope.cacheClearGenesysAndTBARegistration(createNewSession);
    if (this.rootScope.isSSODuplicate) {
      this.sessionLogOutAndLoginForSSO(createNewSession);
    } else {
      this.sessionLogoutAndLoginAgain(createNewSession);
    }
  }

  /****
   * Below method triggers backend api
   * which kills existing sessin and create new on
   * click of yes and on no  too backend api
   * gets triggered but createNewSession = false in this case for NON_SSO
   */

  sessionLogoutAndLoginAgain(createNewSession) {
    this.logOutandLoginAgain(createNewSession).subscribe({
      next: (data: any) => {
        // console.log('data', data);
        if (data) this.handleSessionAsPerUserSelection(createNewSession, data);
      },
      error: (error) => {
        // console.log('Error in creating new session', error);
        this.rootScope.enableAlerts(Constants.ERROR, Constants.API_FAILURE_MSG);
        this.rootScope.captureLogsDb(Constants.API_FAILURE_MSG, Constants.ERROR);
      },
    });
  }

  logOutandLoginAgain(createNewSession) {
    return this.http.get(Global.domainUrl + Global.HANDLE_MULTI_SESSION, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: {
        emailId: this.rootScope.emailId,
        createNewSession: createNewSession,
      },
    });
  }

  /**
   * Below method gets all the application related configuration needed
   * like aws sqs credentials/genesys etc
   */
  getApplicationConfiguration() {
    // console.log('metjod getApplicationConfiguration called');
    return this.http.get(Global.domainUrl + Global.GET_APP_CONFIG, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  /****
   * Below method hits the backend api which frontend
   * let frontend know its duplicate session or not.
   */
  getInfoAbtDuplicateSession() {
    let url =
      Global.domainUrl +
      Global.IS_DUPLICATE_SESSION +
      '/' +
      this.rootScope.emailId;
    //send
    // console.log('url', url);
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  /* istanbul ignore next */
  getUserDetails(session?) {
    this.getUserData().subscribe({
      next: (data: any) => {
        // console.log('user data', data);
        this.rootScope.userData = data['data'];
        /*In CCR3-1156 We Store the lanId and pref_region in sessionStorage for saving the preference value 
        in database(admin) user_setting table.*/
        sessionStorage.setItem('lanId', data?.data?.lanId);
        if (data?.data?.userSettingMap?.ALIS) {
          this.rootScope.preferenceRegion = JSON.parse(
            data?.data?.userSettingMap?.ALIS
          )?.pref_region;
        }
        let clientID = this.rootScope.getObjFromConfigObj(this.rootScope.preferenceRegion + Constants.ALIS_CLIENT_ID);
        if (clientID) {
          this.rootScope.GENESYS_CLOUD_CLIENT_ID = clientID.fieldValue;
          // console.log(Date() + this.rootScope.GENESYS_CLOUD_CLIENT_ID)
          sessionStorage.setItem('ALIS_CLIENT_ID', clientID.fieldValue);
        }
        if (data?.data?.userSettingMap?.LOG) {

          this.rootScope.isLogEnabledUser = JSON.parse(
            data?.data?.userSettingMap?.LOG
          )?.log_type;
          console.log('logTypes======>' + this.rootScope.isLogEnabledUser);

        }
        /**Author @Vamsi Pamidala
         * @isAlisRegistered previouse session alis Registered status base internally login in alis and capturing notifications
         * alis Registered status is false load Research customer accounts in careportal
         * 
         */
        if (this.rootScope.preferenceRegion && data?.data?.isAlisRegistered) {
          sessionStorage.setItem(
            'pref_region',
            this.rootScope.preferenceRegion
          );
          if (session && data?.data?.isAlisRegistered) this.alisRegistration();
        } else if (session && !data?.data?.isAlisRegistered) {
          this.getRestoreAccountDetails();
        } else if (session && !data?.data?.isAlisRegistered) {

        }
        /* End code*/
        if (
          this.rootScope.createNameForUserProfile(
            this.rootScope.userData['firstName'],
            this.rootScope.userData['lastName'],
            this.rootScope.userData['lanId'],
            this.rootScope.userData['browserSessionStartTimestamp']
          )
        ) {
          this.router.navigate(['/']);
        }
      },
      error: (error) => {
        // console.log('Error in getting user details new session', error);
        this.rootScope.enableAlerts(Constants.ERROR, Constants.API_FAILURE_MSG);
        this.rootScope.captureLogsDb(Constants.API_FAILURE_MSG + error, Constants.ERROR);
      },
    });
  }

  getUserData() {
    let url =
      Global.domainUrl + Global.GET_USER_DETAILS + this.rootScope.sessionId;

    // console.log('url', url);
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  sessionLogOutAndLoginForSSO(createNewSession) {
    this.logOutandLoginAgainForSSO(createNewSession).subscribe({
      next: (data: any) => {
        // console.log('data', data);
        if (data) this.handleSessionAsPerUserSelection(createNewSession, data);
      },
      error: (error) => {

        // console.log('Error in creating new session', error);
        this.rootScope.enableAlerts(Constants.ERROR, Constants.API_FAILURE_MSG);
        this.router.navigate(['/ssoerror']);
        this.rootScope.captureLogsDb(Constants.API_FAILURE_MSG + error, Constants.ERROR);
      },
    });
  }

  handleSessionAsPerUserSelection(createNewSession, data) {
    // console.log(
    //   'Method handleSessionAsPerUserSelection called ',
    //   createNewSession
    // );
    if (createNewSession) {
      data = data.httpStatusCode == HttpStatusCode.Ok ? data.data : data;
      /****Here previous opened will be redirected to google default home page ***/
      //  data = data.httpStatusCode == HttpStatusCode.Ok ? data.data : data;

      this.rootScope.sessionId = data?.jSessionId;
      this.rootScope.browserSessionStartTimestamp = data["browserSessionStartTimestamp"];
      sessionStorage.setItem('restoreSession', 'false');
    }
    else {
      this.rootScope.sessionId = data.data?.jSessionId;
      this.rootScope.browserSessionStartTimestamp = data?.data["browserSessionStartTimestamp"];
      sessionStorage.setItem('restoreSession', 'true');
      /**** Here new opened tab will be redirected to google default home page ***/
      // window.open('http://www.google.com', '_self');
    }

    this.getUserDetails(!createNewSession);
    sessionStorage.setItem('sessionId', this.rootScope.sessionId); localStorage.setItem('sessionId', this.rootScope.sessionId);
    sessionStorage.setItem('browserSessionStartTimestamp', this.rootScope.browserSessionStartTimestamp);
    this.rootScope._isAuthenticated.next(true);
    this.rootScope.loadUI = true;
    /* istanbul ignore next */ // start browser time stamp subscribtion and monitor inactiveity in application 
    this.validateTimeStampToken();
    this.rootScope.setTimeOutDetails({ 'watch': true, 'stop': false });
  }

  logOutandLoginAgainForSSO(createNewSession: any) {
    return this.http.get(Global.domainUrl + Global.HANDLE_MULTI_SESSION_SSO, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: {
        emailId: this.rootScope.emailId,
        createNewSession: createNewSession,
        oldSessionId: (this.rootScope.oldSessionId || sessionStorage.getItem('sessionId') || ""),
        newSessionId: this.rootScope.newSessionId,
      },
    });
  }

  /**
   * Below is a common method to communicate to backend for this api
   * @param keyName
   * @returns
   */

  getDataByCommonKeyValueApi(keyName) {
    let url = `${Global.domainUrl + Global.dashboardApi.ALISRegionsUrl
      }?validFieldKey=${keyName}`;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  /**
   * @author : Amarjeet Kumar
   * calling 3 custome accounr apis togather in sequence
   * @param : 'customer-type','CHANNEL-LIST' & 'DOMAIN-LIST'
   * API 1- customer-type list on main customer account page
   * API 2- channel list for IH filter popup
   * API 3- Third Party dropdown list list for wrapup page
   */
  customerAccountApis() {
    let customerType = this.getDataByCommonKeyValueApi(Constants.CUSTOMER_TYPE).pipe(catchError((err) => {
      this.rootScope.customerTypeAPIFailure = true;
      return of({ isError: true, error: err });
    })
    );
    let channelList = this.getDataByCommonKeyValueApi(Constants.CHANNEL_LIST).pipe(catchError((err) => of({ isError: true, error: err })));
    let thirdPartyList = this.getDataByCommonKeyValueApi(Constants.THIRD_PARTY_LIST).pipe(catchError((err) => of({ isError: true, error: err })));
    let primaryLanguage = this.getDataByCommonKeyValueApi(Constants.PRIMARY_LANGUAGE).pipe(catchError((err) => of({ isError: true, error: err })));
    let preferredLocale = this.getDataByCommonKeyValueApi(Constants.PREFERRED_LOCALE).pipe(catchError((err) => of({ isError: true, error: err })));
    let unknownCallerType = this.getDataByCommonKeyValueApi(Constants.UNKNOWN_CALLER_TYPE_LIST).pipe(catchError((err) => {
      this.rootScope.unknownCallerTypeAPIFailure = true;
      return of({ isError: true, error: err });
    }));
    forkJoin([customerType, channelList, thirdPartyList, unknownCallerType, primaryLanguage, preferredLocale]).subscribe((res: any) => {
      if (res) {
        this.rootScope.customerTypeData = res[0]?.data?.body;
        let IHChannelList = res[1]?.data?.body;
        let unknownCallerTypeList = res[3]?.data?.body;
        this.rootScope.thirdPartyList = res[2]?.data?.body;
        this.rootScope.primaryLanguage = res[4]?.data?.body;
        this.rootScope.preferredLocale = res[5]?.data?.body;

        if (IHChannelList) {
          IHChannelList.sort((a, b) => parseFloat(a.sequence) - parseFloat(b.sequence));
          this.rootScope.IHChannelList = IHChannelList;
        }

        if (unknownCallerTypeList) {
          unknownCallerTypeList.sort((a, b) => a.fieldValueDescription.localeCompare(b.fieldValueDescription)); 
          this.rootScope.unknownCallerTypeList = unknownCallerTypeList;
        }
      }
    })
  }

  getIHDataForBriefView() {
    let url = Global.domainUrl + Global.GET_IH_BRIEF_DATA;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        clientId: this.rootScope.activeCustTab.clientId,
        searchId: this.rootScope.activeCustTab.id
      }
    });
  }

  getIHDataForListView() {
    let url = Global.domainUrl + Global.GET_IH_LIST_DATA;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        clientId: this.rootScope.activeCustTab.clientId,
        searchId: this.rootScope.activeCustTab.id
      }
    });
  }


  /* @author :vamsi pamidala
  Validate the timestamp and avoid duplicate/multisession in careportal 
  every 5 sec silent api request will send to api to verify the timestamp 
if its sucess it will print in console other wise it will route to session expiry page 
   */
  /* istanbul ignore next */
  validateTimeStampToken() {
    this.rootScope.browserSubscription = timer(0, this.rootScope.CCTConfigs.ACTIVE_SESSION_EVALUATE_INTERVAL).pipe(
      switchMap(() => this.newAgentApiService.getApi(Global.isSessionActive, { browerStartTimeStamp: this.rootScope.browserSessionStartTimestamp || sessionStorage.getItem('browserSessionStartTimestamp') || new Date().toLocaleDateString() }, 'false', false))
    ).subscribe({
      next: (res) => {
        // if (res) {
        //   let expiryAt = localStorage.getItem('ng2Idle.main.expiry');

        //   if (expiryAt)
        //     console.log('idle' + new Date(parseInt(expiryAt)));
        // }
      },
      error: (error) => {
        if (this.rootScope.isAuthenticate) {
          this.rootScope.sessionExpiry = true;
          this.appTimeOut();
          sessionStorage.setItem('sessionExpiry', "true");
        } else {
          console.log(error);
          this.rootScope.captureLogsDb(Constants.API_FAILURE_MSG + error, Constants.ERROR);
        }
      }
    }
    );

  }



  /**Author @Vamsi Pamidala
   * get all previous session details when user refresh/duplicate/crashing the applicaion 
   * User relaunch the application user can choose open new session and Restore account
   * User click on Restore button get all Customer account (Research/live call/chat/additional account)
   * if api fails it will show message in console and snackbar
   */
  getRestoreAccountDetails() {

    this.newAgentApiService.getApi(Global.customerApi.getRestoreAccountDetails, null, 'false', false)
      .subscribe({
        next: (res) => {
          /* istanbul ignore next */
          if (res && res.data != Constants.errorObj.restoreError && res.data?.length) {

            let additionalAccounts = res.data.filter(x => x.cusTab?.additionalAccount);
            this.rootScope.restoreSession = this.rootScope.getValueFromSessiondb('restoreSession', false);
            // set sequence both additionalAccounts and primary 
            if (this.rootScope.restoreSession && additionalAccounts?.length > 0) {
              additionalAccounts.forEach(additionalAcc => {
                if (additionalAcc.conversationId) {
                  let accountIndex = res.data.findIndex(x => x.globalIdentifierId == additionalAcc.globalIdentifierId && x.cusTab.conversationId == additionalAcc.cusTab.conversationId);
                  let parentAccIndex = res.data.findIndex(x => x.globalIdentifierId == additionalAcc?.cusTab?.parentId && x.cusTab.conversationId == additionalAcc?.cusTab.conversationId);
                  res.data.splice(accountIndex, 1);
                  res.data.splice(parentAccIndex + 1, 0, additionalAcc);
                }
              });
            }
            setTimeout(() => {
              res.data.forEach((element, index) => {
                if (element.cusTab.id) {
                  element.cusTab.restoreTab = true;
                  this.rootScope.customerTabs.push(element.cusTab);
                  this.genesysCloudService.getRestoreCompAccDetails(element.cusTab);
                }
                if (index + 1 == res.data?.length && this.rootScope.isGenesysLoggedIn) {
                  this.sendReqToGetLiveInteraction(true);
                }
              });
            }, additionalAccounts?.length > 0 ? 100 : 0);


            console.log(res);
          } else this.sendReqToGetLiveInteraction();
        },
        error: (error) => {
          console.log(error); this.sendReqToGetLiveInteraction(); this.rootScope.enableAlerts(
            Constants.ERROR,
            Constants.AlertMsg.error500
          );
          this.rootScope.captureLogsDb("GET-RESTORE-ACCOUNT-FAILURE" + error, Constants.ERROR);
        }
      })
  }

  sendReqToGetLiveInteraction(openAccount?) {
    if (this.rootScope.isGenesysLoggedIn || this.rootScope.getValueFromSessiondb('connectToGenesys', false)) {
      this.genesysCloudService.saveAllQueueFromGen();
      /* istanbul ignore next */
      if (openAccount && this.rootScope.restoreSession) {
        let liveCallAccount = this.rootScope.customerTabs.filter(x => x.conversationId && x.conversationId != "NA" && x.channel == Constants.IH_CALL && !x.additionalAccount);
        let liveChatAccount = this.rootScope.customerTabs.filter(x => x.conversationId && x.conversationId != "NA" && x.channel == Constants.IH_CHAT && !x.additionalAccount);

        if (liveCallAccount?.length > 0) {
          this.rootScope.isLiveCall = true;

        } else if (liveChatAccount?.length > 0) {
          this.rootScope.isLiveChat = true;
          // For CCR3-3830
          if (this.rootScope.checkLiveChatAccount()) {
            this.rootScope.setTimeOutDetails({ 'watch': false, 'stop': true });
          }
        }
        // find the live call/chat account update local varibale (islivecall,islivechat)
        this.genesysCloudService.restoreLiveData = liveChatAccount.concat(liveCallAccount);
        if (this.genesysCloudService.restoreLiveData?.length > 0) {
          this.genesysCloudService.restoreLiveData?.forEach(element => {
            if (element.channel == Constants.IH_CALL) {
              this.genesysCloudService.checkConversationsCall(element.conversationId, element);//check live call status based on conversation id
            }
            else if (element.channel == Constants.IH_CHAT) {
              this.genesysCloudService.checkConversationsChat(element.conversationId, element);//check live chat status based on conversation id
            }

          });
        }

      }
      setTimeout(() => {
        this.genesysCloudService.getLiveInteractions();
      }, 2000);

    }
  }

  alisRegistration() {
    if (!this.rootScope.getValueFromSessiondb('connectToGenesys', false) && this.rootScope.appConfigObj && this.rootScope.preferenceRegion) {
      let fieldName = this.rootScope.preferenceRegion + '_AUTH_URL';
      let regionObj = this.rootScope.getObjFromConfigObj(fieldName);
      this.genesysCloudService?._environment.next(regionObj?.fieldValue);
      this.rootScope._ALISSelectedRegionObj.subscribe((res) => {
        sessionStorage.setItem('ALISRegisteredRegionObj', JSON.stringify(res));
      });
      this.genesysCloudService.sendMessage(true);
      sessionStorage.setItem('connectToGenesys', 'true'); sessionStorage.setItem('ALISRegistration', 'true');
    }
  }

  /**
   * @author :Pooja 
   * @returns 
   */

  getRepeatAlertMsg() {

    let url = Global.domainUrl + Global.GET_REPEAT_ALERT;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: {
        contactId: this.rootScope.activeCustTab.id,
        callerType: this.rootScope.activeCustTab.defaultRole
      }
    });
  }

  /**
 * Retrieves customer types data from a common key-value API.
 * This method updates the `customerTypeData` property in the root scope
 * with the fetched data and sets `customerTypeAPIFailure` to true
 * in case of an error.
 */
  getCustomerTypesAPI() {
    this.rootScope.customerTypeAPIFailure = false;
    this.getDataByCommonKeyValueApi(Constants.CUSTOMER_TYPE).subscribe({
      next: (res: any) => {
        this.rootScope.customerTypeData = res.data?.body;
      },
      error: (err) => {
        this.rootScope.customerTypeAPIFailure = true;
        this.rootScope.captureLogsDb("GET-CUSTOMER-TYPE-API-FAILURE" + err, Constants.ERROR);
      }

    })
  }

  getAlertTypes() {
    let url = Global.domainUrl + Global.ALERTS_TEMPLATES;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: {
        clientId: this.rootScope.activeCustTab.clientId
      }
    });
  }

  creatAlerts(reqBody) {
    let url = Global.domainUrl + Global.CREATE_ALERTS;
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });

  }

  /** 
  * getAllAlerts() -- calling API to get all alerts list.
  * @author :Amarjeet Kumar
  */
  getAlertList() {
    let url = Global.domainUrl + Global.CREATE_ALERTS;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        clientId: this.rootScope.activeCustTab.clientId
      }
    });
  }

  saveEditAlertData(runtimeAlertId, reqBody) {
    let url = Global.domainUrl + Global.SAVE_EDIT_ALERTS + runtimeAlertId;
    return this.http.put(url, reqBody, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  deleteAlert(runtimeAlertId) {
    let url = Global.domainUrl + Global.SAVE_EDIT_ALERTS + runtimeAlertId;
    return this.http.delete(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  getDomainList() {
    let url = Global.domainUrl + Global.GET_TOPIC_LIST;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: {
        clientId: this.rootScope.activeCustTab.clientId
      }
    });
  }

  getFilterDomainList() {
    let url = Global.domainUrl + Global.GET_TOPIC_LIST;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
    });
  }

  setAccountSecurityDt(model, body) {

    let accountDt = this.rootScope.activeCustTab;
    let ParticipantId = (accountDt.customerParticipantId != 'NA' && accountDt.customerParticipantId ? accountDt.customerParticipantId : this.rootScope.getParticipantId());
    this.genesysCloudService.updateSecurityLevelInGEN(accountDt.conversationId, ParticipantId, body, model);

  }


  /* istanbul ignore next */
  appTimeOut() {
    console.log('log-out App');
    this.rootScope._isAuthenticated.next(false);
    /* istanbul ignore next */
    this.rootScope._isLogout.next(true);
    this.genesysCloudService.logOutALIS(true);
    sessionStorage.clear();

  }

  /**
   * Below method handles dynmic timer seconds running a counter down secs and
   * stop timer session once it reaches zero sec
   * 
   */
  appSessionTimer() {
    setTimeout(() => {
      if (!this.rootScope.loadUI) {
        this.appTimeOut();
      }
    }, this.rootScope.CCTConfigs.APP_SESSION_TIMEOUT * 1000);
  }

  /**
   * Below method is used to fetch Document Data
   * @param paramsObject 
   * @returns 
   */
  getDataToViewDocument(paramsObject) {
    let url = Global.domainUrl + Global.GET_DOCUMENT_CONTENT;

    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: paramsObject,
      responseType: 'arraybuffer'
    });
  }

  /** 
  * getIHMessageData(paramsObject) -- Calling API to get IH message.
  * @author :Amarjeet Kumar
  */
  getIHMessageData(paramsObject) {
    let url = Global.domainUrl + Global.GET_MESSAGE_CONTENT;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: paramsObject,
      responseType: 'arraybuffer'
    });
  }


  getAutoLaunchConfigData(clientID) {
    let params = { clientId: clientID }
    let url = Global.domainUrl + Global.customerApi.autoLaunchAPI;
    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: params
    });
  }


  /**
   * Below method is used to fetch agent InteractionData.
   * @param paramsObject 
   * @returns 
   */
  getAgentInteractionData(paramsObject) {
    let url = Global.domainUrl + Global.GET_AGENT_INTERACTION_DATA;

    return this.http.get(url, {
      headers: this.rootScope.getCommonHeaders(Constants.apiVersions),
      params: paramsObject
    });
  }

  globalIconIdUpdate(id) {
    let favIcon = document.getElementById(Constants.applicationId);
    this.rootScope.globalIconId = id?.toString();
    favIcon?.setAttribute('id', Constants.applicationId + this.rootScope.globalIconId);
  }

  globalIconUpdate(warning?) {
    let favIcon = document.getElementById(Constants.applicationId + this.rootScope.globalIconId);

    if (warning)
      favIcon?.setAttribute('href', './../../assets/images/warning.png');
    else favIcon?.setAttribute('href', './../../assets/images/favicon.png');
  }

  /**
 * Below method fetch the unknown caller type list from the backend.
 */
  getUnknownCallerTypes() {
    this.rootScope.unknownCallerTypeAPIFailure = false;
    this.getDataByCommonKeyValueApi(Constants.UNKNOWN_CALLER_TYPE_LIST).subscribe({
      next: (res: any) => {
        let unknownCallerTypeList = res?.data?.body;

        if (unknownCallerTypeList) {
          unknownCallerTypeList.sort((a, b) => a.fieldValueDescription.localeCompare(b.fieldValueDescription)); 
          this.rootScope.unknownCallerTypeList = unknownCallerTypeList;
        }
      },
      error: (err) => {
        this.rootScope.unknownCallerTypeAPIFailure = true;
        this.rootScope.captureLogsDb("GET-UNKNOWN-CALLER-TYPE-API-FAILURE" + err, Constants.ERROR);
      }
    })
  }



}
